import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import LandingPage from "@/pages/LandingPage";
import QuoteBuilder from "@/pages/QuoteBuilder";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { FranchiseProvider } from "@/context/FranchiseContext";

// Wrapper component to provide franchise context
function FranchiseRoute({ children }) {
  return <FranchiseProvider>{children}</FranchiseProvider>;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Default routes (Naperville-Elmhurst) */}
          <Route path="/" element={<FranchiseRoute><LandingPage /></FranchiseRoute>} />
          <Route path="/quote" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
          
          {/* Franchise routes - path-based */}
          <Route path="/:franchiseSlug" element={<FranchiseRoute><LandingPage /></FranchiseRoute>} />
          <Route path="/:franchiseSlug/quote" element={<FranchiseRoute><QuoteBuilder /></FranchiseRoute>} />
          
          {/* Admin routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/reset-password" element={<AdminLogin />} />
          <Route path="/admin/*" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
